<template>
  <div class="table-sizes">
    <div
      class="table-sizes__wrapper overflow-hidden border-stroke-outermost border-radius-lg"
    >
      <div
        class="table-sizes__shedule scroll-slider d-sm-flex text-center relative"
      >
        <div
          class="table-sizes__header grid-row grid-row_empty d-flex_sm-column text-sm-left border-bottom-stroke-outermost"
        >
          <div
            class="grid-col grid-col_same"
            v-for="(column, index) of columns"
            :key="index"
          >
            <div class="py-20 px-8">
              <div class="fw-light fs-sm-12">{{ column.name }}</div>
            </div>
          </div>

          <div class="grid-col grid-col_same">
            <div class="p-8 pl-sm-0">
              <div class="fw-light fs-sm-12">Длина стопы, см</div>
              <div class="fs-12 fs-sm-10 text-grey-strong mt-2 mt-sm-0">
                Возможна погрешность ±2 мм
              </div>
            </div>
          </div>
        </div>
        <div
          class="table-sizes__item grid-row grid-row_empty radius-sm-sm d-flex_sm-column"
          v-for="(param, index) of getSizeMapRows"
          :key="param.id"
          :class="currentSize === index ? 'is-active' : ''"
          @click="xmlId = index"
        >
          <div
            class="grid-col grid-col_same"
            v-for="(column, index) of columns"
            :key="index"
          >
            <div class="p-8">
              {{ param[column.prop] }}
            </div>
          </div>
          <div class="grid-col grid-col_same">
            <div class="p-8">
              {{ param.uf_foot_size }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-16 text-center">
      <div
        class="btn btn_lg color-dark hover-color-hover-primary"
        @click="toogleStates()"
      >
        <div class="mr-12 fs-18 fw-medium">Как измерить стопу</div>
        <div class="active-rotate-180" v-bind:class="{ 'is-active': isActive }">
          <Icon iconName="icon-chevron-down" />
        </div>
      </div>
    </div>

    <div class="mt-16 scroll-slider mx-md-n16 px-md-16" v-if="isActive">
      <div class="grid-row grid-row_sm">
        <div class="grid-col grid-col_25 grid-col_sm-auto">
          <div class="table-sizes__image">
            <img src="../../assets/images/popup-sizes-step1.png" alt="step" />
          </div>
        </div>
        <div class="grid-col grid-col_25 grid-col_sm-auto">
          <div class="table-sizes__image">
            <img src="../../assets/images/popup-sizes-step2.png" alt="step" />
          </div>
        </div>
        <div class="grid-col grid-col_25 grid-col_sm-auto">
          <div class="table-sizes__image">
            <img src="../../assets/images/popup-sizes-step3.png" alt="step" />
          </div>
        </div>
        <div class="grid-col grid-col_25 grid-col_sm-auto">
          <div class="table-sizes__image">
            <img src="../../assets/images/popup-sizes-step4.png" alt="step" />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-32 text-center">
      <button
        class="btn btn_lg btn_px-lg btn_fill-tertiary border-radius-md"
        @click="selectSize"
      >
        Выбрать размер
      </button>
    </div>

    <div class="mt-24 text-center">
      <button
        class="btn color-gray hover-color-hover-primary"
        @click.prevent="openVideoCall()"
      >
        <span class="d-block icon-20 mr-8">
          <svg>
            <use
              xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg#icon-camera-security"
            ></use>
          </svg>
        </span>
        <span class="d-block">Мне необходима видеоконсультация</span>
      </button>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "TableSizes",
  components: {
    Icon,
  },
  data() {
    return {
      xmlId: "",
      activeIndex: null,
      isActive: false,
      columns: [
        {
          name: "Российский размер",
          prop: "uf_size_ru",
        },
        {
          name: "Размер производителя",
          prop: "uf_size",
        },
      ],
    };
  },
  setup() {
    const storeCatalog = useProductStore();

    return {
      storeCatalog,
    };
  },
  inject: ["closePopup"],
  computed: {
    ...mapState(useProductStore, ["getSizeMapRows", "getSizeGuid"]),
    currentSize() {
      return this.xmlId === "" ? this.getSizeGuid : this.xmlId;
    },
  },
  methods: {
    toogleStates() {
      this.isActive = !this.isActive;
    },
    selectSize() {
      this.storeCatalog.isSelected.size = true;
      this.storeCatalog.selectOfferBySizeGuid(this.currentSize);
      this.closePopup();
    },
    openVideoCall() {
      this.closePopup();
      window.openCallPopup();
    },
  },
  mounted() {
    let sizeMapRows = this.getSizeMapRows || {};
    let guidBrand = Object.values(sizeMapRows)[0]?.uf_guid_brand;

    // brand BERKEMANN
    if (guidBrand === "9831a39a-3b9c-11e9-879e-3c4a9274df28") {
      this.columns = [
        {
          name: "Размер производителя",
          prop: "uf_size",
        },
        {
          name: "Английский размер",
          prop: "uf_size_uk",
        },
        {
          name: "Российский размер",
          prop: "uf_size_ru",
        },
      ];
    }
  },
};
</script>

<style lang="scss">
@import "./table-sizes.scss";
</style>
